console.info('js/favorites.js -> v0.1.1');

(() => {
  const favoriteButton = document.querySelector('button.gallery-favorite');

  if (!favoriteButton) {
    return false;
  }

  favoriteButton.addEventListener('click', function(event) {
    toggleFavorite(event);
  });

  const toggleFavorite = (event) => {
    const button = event.target;
    const csrfToken = event.target.dataset.csrfToken;
    const listingId = event.target.dataset.listingId;
    const referenceCode = event.target.dataset.referenceCode;
    const currencyCode = event.target.dataset.currencyCode;
    let isFavorite = event.target.dataset.isFavorite;
    let method = '';

    // not optimal, comparing string values
    if (isFavorite == "true") {
      method = 'DELETE';
    }
    else {
      method = 'PUT';
    }

    const url = '/favorites/ref/' + referenceCode;

    const params = {
      credentials: 'same-origin',
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken
      }
    }

    button.classList.add('is-loading');
    
    fetch(url, params)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Something went wrong with favoriting this listing');
    })
    .then(data => {
      event.target.setAttribute('data-is-favorite', data.isFavorite);
      button.classList.remove('is-loading');

      if (data.isFavorite == true) {
        event.target.classList.add('is-favorite');
				toast.info(wishAdd, { delay: 2500 }, toast.fade);
      }
      else {
        event.target.classList.remove('is-favorite');
				toast.info(wishRemove, { delay: 2500 }, toast.fade);
      }

    })
    .catch(error => {
      console.log(error);
    });
  }
})();


$(function() {
	$('.favorite, .favorite-new-showcard, .favorite--preventDefault.not-logged-in').on('click', function(ev) {
		ev.stopPropagation();
	});

	$('.favorites').on('click', function(ev) {
		var el = $(this);
		var method;

		if (el.hasClass("svg-wrapper")) {
			if (el.hasClass("favorite-full")) {
				el.removeClass("favorite-full").addClass("favorite-empty");
				method = 'DELETE';
				if ($(this).hasClass('makes-toast')) {
					$('.toast-alert').fadeOut(1000, function() {
						$(this).remove();
					});
					toast.info(wishRemove, null, toast.fade)
				}
			} else {
				el.removeClass("favorite-empty").addClass("favorite-full");
				method = 'PUT';
				if($(this).hasClass('makes-toast')) {
					$('.toast-alert').fadeOut(1000, function() {
						$(this).remove();
					});
					toast.info(wishAdd, null, toast.fade)
				}
			}
		} else {
			if (el.hasClass("ebs-icon-heart")) {
				el.removeClass("ebs-icon-heart").addClass("ebs-icon-heart-stroked");
				method = 'DELETE';
				el.parent().removeClass('added').addClass('not-added');
				el.removeClass('tada');
				el.addClass('unlike');
				el.trigger('mouseout');

				if ($(this).hasClass('makes-toast')) {
					$('.toast-alert').fadeOut(1000, function() {
						$(this).remove();
					});
					if($('body').hasClass("logged-in")) {
						toast.favorite(wishRemove, null, toast.fade)
					} else {
						toast.favorite(wishRemove, {
							buttonText: wishLoginButton,
							buttonURL: '#plt-login-modal',
							dataToggle: 'modal'
						}, toast.fade)
						$('.toast-alert a').on('click', function(event) {
							$(this).parent().remove();
						});
					}
				}
			} else if (el.hasClass("ebs-icon-heart-stroked")) {
				el.removeClass("ebs-icon-heart-stroked").addClass("ebs-icon-heart");
				method = 'PUT';
				el.parent().removeClass('not-added').addClass('added');

				el.addClass('tada');
				el.removeClass('unlike');
				el.trigger('mouseout');
				if($(this).hasClass('makes-toast')) {
					$('.toast-alert').fadeOut(1000, function() {
						$(this).remove();
					});
					if($('body').hasClass("logged-in")) {
						toast.favorite(wishAdd, null, toast.fade)
					} else {
						toast.favorite(wishAdd, {
							buttonText: wishLoginButton,
							buttonURL: '#plt-login-modal',
							dataToggle: 'modal'
						}, toast.fade)
						$('.toast-alert a').on('click', function(event) {
							$(this).parent().remove();
						});
					}
				}
			} else if (el.hasClass("favorite-listing") || el.hasClass("hide-on-mobile")) {
				let heartStrokeIcon = document.querySelector('.ebs-icon.ebs-icon--main.ebs-icon-heart-stroked');
				let heartIcon = document.querySelector('.ebs-icon.ebs-icon--main.ebs-icon-heart');
				if (heartStrokeIcon) {
					heartStrokeIcon.classList.replace('ebs-icon-heart-stroked', 'ebs-icon-heart');
					method = 'PUT';

					if(el.hasClass('makes-toast')) {
						$('.toast-alert').fadeOut(1000, function() {
							$(this).remove();
						});

						const body = document.querySelector('body')
						if(body.classList.contains('logged-in')) {
							toast.favorite(wishAdd, null, toast.fade)
						} else {
							toast.favorite(wishAdd, {
								buttonText: wishLoginButton,
								buttonURL: '#plt-login-modal',
								dataToggle: 'modal'
							}, toast.fade)
							$('.toast-alert a').on('click', function(event) {
								$(this).parent().remove();
							});
						}
					}
				} else if (heartIcon) {
					heartIcon.classList.replace('ebs-icon-heart', 'ebs-icon-heart-stroked');
					method = 'DELETE';

					if (el.hasClass('makes-toast')) {
						$('.toast-alert').fadeOut(1000, function() {
							$(this).remove();
						});
						const body = document.querySelector('body')
						if(body.classList.contains('logged-in')) {
							toast.favorite(wishRemove, null, toast.fade)
						} else {
							toast.favorite(wishRemove, {
								buttonText: wishLoginButton,
								buttonURL: '#plt-login-modal',
								dataToggle: 'modal'
							}, toast.fade)
							$('.toast-alert a').on('click', function(event) {
								$(this).parent().remove();
							});
						}
					}
				}
			}
		}

		const listingID = el.data('listing-id');
		const referenceCode = el.data('reference-code');
		const csrfToken = el.data('csrf-token');

    console.log(method);

		$.ajax({
			type: method,
			url: "/favorites/ref/" + referenceCode,
			async: true,
			headers: {
				'X-CSRF-Token': csrfToken
			}
		}).done(function(data) {
			if (data) {
				$('#user_favorite_count').html( data.count );
				$('.navbar__nav-wishlist .count').html( data.count );
				$('.user_favorite_count').html( data.count );

				if($(".current_site_favorite_count").length)
					$(".current_site_favorite_count").html( "(" + data.currentSiteCount + ")" );

				if($(".other_sites_favorite_count").length)
					$(".other_sites_favorite_count").html( "(" + data.otherSitesCount + ")");
			}
		});

		if(method === 'PUT') {
			let currencyCode = el.data('currency-code');

			let listingPrice = el.data('total-listing-price');
			if(typeof listingPrice == "string") {
				listingPrice = Number(listingPrice.replace(',', ''));
			}

			//push custom event to google tagmanager
			window.dataLayer.push({
				'event': 'add_listing_to_favorites',
				'favorited_listing_id' : listingID,
				'favorited_listing_price' : listingPrice,
				'favorited_listing_price_currency' : currencyCode,
			});
		}

		gae('softgoal', 'wishlist');
		gae('wishlist','button_toggle')
		ev.preventDefault();
		ev.stopPropagation();
		return false;
	});

});

$('.favorite--preventDefault').click(function(event){
	event.preventDefault();
	event.stopPropagation();
});

function openLoginModal(event) {
	if (event) {
		event.preventDefault();
		event.stopPropagation();
	}
	var loginPartnerSection = document.querySelectorAll('.partner-cta-container');
	if(loginPartnerSection !== null) {
		for (var i = 0; i < loginPartnerSection.length; ++i) {
			loginPartnerSection[i].classList.add('hide');
		}
	}
	$('#plt-login-modal').modal('show');
	return false;
};

const favoritesPagination = (() => {
    document.addEventListener('DOMContentLoaded', function(event) {
		const favoritesPaginationContainer = document.querySelector('.favorites-pagination');
		if(favoritesPaginationContainer) {
			favoritesPagination.initPaginationConfig();
			const count = parseInt(document.querySelector('#favorites-count').value);
			const totalNoOfPages = favoritesPagination.totalPages(count, window.PAGE_LIMIT);
			favoritesPagination.renderPagination(count, totalNoOfPages, window.CURRENT_PAGE);
		}
    });

    /**
	 * @method initPaginationConfig
	 * @method renderPagination
	 * @method totalPages
	 * @method getPagination
     * @method setPagination
	 */

	return {

		initPaginationConfig: () => {
			let urlParams = new URLSearchParams(window.location.search);
            const hasPageNumber = urlParams.has('page');
			hasPageNumber ? window.CURRENT_PAGE = parseInt(urlParams.get('page')) : window.CURRENT_PAGE = 1;
			window.PAGE_LIMIT = 12;
		},

		totalPages: (count, limit) => {
			let noOfPages = Math.ceil(count/limit);
			return noOfPages;
		},

		getPagination: (count, currentPage) => {
			let totalResults = count;
			let pageLimit = window.PAGE_LIMIT;
			let totalPages = favoritesPagination.totalPages(count, window.PAGE_LIMIT);
			let startPage = 0;
			let endPage = 0;
			if (totalPages <= 5) {
				startPage = 1;
				endPage = totalPages;
			} else {
				if (currentPage <= 3) {
					startPage = 1;
					endPage = 5;
				} else if (currentPage + 2 >= totalPages) {
					startPage = totalPages - 4;
					endPage = totalPages;
				} else {
					startPage = currentPage - 2;
					endPage = currentPage + 2;
				}
			}

			let startIndex = (currentPage - 1) * pageLimit;
			let endIndex = Math.min(startIndex + pageLimit - 1, totalResults - 1);

			let pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);
			return {
				currentPage: currentPage,
				totalPages: totalPages,
				startPage: startPage,
				endPage: endPage,
				startIndex: startIndex,
				endIndex: endIndex,
				pages: pages
			};
		},

		setPagination: (count, page) => {
			if (page < 1 || page > count) {
				return;
			}
			favoritesPagination.getPagination(page);
			window.CURRENT_PAGE = page;
			const url = new URL(window.location.href);
			url.searchParams.set('page', page);
			window.location.href = url.toString();
		},

		renderPagination: (count, totalNoOfPages, index) => {
			let pager = favoritesPagination.getPagination(count, window.CURRENT_PAGE);
			let paginationContainer = document.querySelector('.favorites-pagination-container');
			let paginationContent = '';
			if (pager.pages.length <= 1) {
				paginationContainer.innerHTML = paginationContent;
				return;
			}

			let prevLinkClass = 'hidden';
			let nextLinkClass = '';
			if(pager.currentPage > 1) {
				prevLinkClass = '';
			}
			if(index == totalNoOfPages) {
				nextLinkClass = 'hidden';
			}
			paginationContent = `<a class="favorites-pagination-prev ${prevLinkClass}" onclick="favoritesPagination.setPagination(${count}, ${pager.currentPage - 1})">Previous Page</a>`;
			pager.pages.map(page => {
				let paginationLinkClass = '';
				if(pager.currentPage == page) {
					paginationLinkClass = 'active';
				}
				paginationContent += `<a class="favorites-pagination-link ${paginationLinkClass}" onclick="favoritesPagination.setPagination(${count}, ${page})">${page}</a>`
			})
			paginationContent += `<a class="favorites-pagination-next ${nextLinkClass}" onclick="favoritesPagination.setPagination(${count}, ${pager.currentPage + 1})">Next Page</a>`
			paginationContainer.innerHTML = paginationContent;
		}

	}
})();

// Favorites share functionality
const favoritesShare = (() => {
	function buildShareUrl(base, token) {
		return window.location.origin + '/sharing/' + token;
	}

	function updateModalForListing(url, title, listingId, organizerId) {
		const container = document.querySelector('.share-container');
		if (!container) return;

		// Generate a fresh token for this share action
		let token = '';
		for (let i = 0; i < 10; i++) {
			const rand = Math.floor(Math.random() * 62);
			const code = rand + (rand > 9 ? (rand < 36 ? 55 : 61) : 48);
			token += String.fromCharCode(code);
		}
		const shareUrl = buildShareUrl(window.location.origin, token);

		// Update share container data attributes
		container.dataset.lid = listingId;
		container.dataset.oid = organizerId;
		container.dataset.campaign = 'listing';
		container.dataset.urlShard = encodeURIComponent(title);

		// Update hidden inputs
		const nameInput = document.querySelector('#sharing-listing-name');
		const hashInput = document.querySelector('#sharing-hash');
		if (nameInput) nameInput.value = title;
		if (hashInput) hashInput.value = token;

		// Update social button hrefs
		const encodedUrl = encodeURIComponent(shareUrl);
		const encodedTitle = encodeURIComponent(title);

		const hrefs = {
			facebook:  `https://www.facebook.com/share.php?u=${encodedUrl}`,
			twitter:   `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
			whatsapp:  `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
			email:     `mailto:?subject=${encodedTitle}&body=${encodedTitle}%0A%0A${shareUrl}`,
			telegram:  `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
		};

		Object.entries(hrefs).forEach(([platform, href]) => {
			const el = container.querySelector(`.share__link.${platform}`);
			if (el) el.setAttribute('href', href);
		});

		// Update copy-link input
		const generatedLink = container.querySelector('.generated-link');
		if (generatedLink) generatedLink.value = shareUrl;

		// Register the token with the server upfront so share URLs always resolve,
		// regardless of whether referral-share.js fires on the actual social button click.
		// Must use valid ReferralType and ReferralSource enum values from referrals.d.
		fetch(`/sharing/${token}`, {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify({
				type: 'copy-link',
				source: 'listing',
				listing_id: Number(listingId),
				inquiry_id: null,
				position: ''
			}),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		}).catch(() => {});
	}

	document.addEventListener('click', function(e) {
		const btn = e.target.closest('.showcard-share-btn');
		if (!btn) return;

		// Close the dropdown
		const dropdown = btn.closest('.showcard-dropdown-menu');
		if (dropdown) dropdown.classList.remove('active');

		const url      = btn.dataset.listingUrl || window.location.href;
		const title    = btn.dataset.listingTitle || '';
		const listingId   = btn.dataset.listingId || '0';
		const organizerId = btn.dataset.organizerId || '0';

		updateModalForListing(url, title, listingId, organizerId);
		$('#listing-share-modal').modal('show');
	});

	$('#listing-share-modal')
		.on('show.bs.modal', function() {
			document.body.style.overflow = 'hidden';
		})
		.on('hidden.bs.modal', function() {
			document.body.style.overflow = '';
		});
})();

// Favorites tabs functionality
const favoritesTabs = (() => {
	const TAB_EMPTY_STATE = {
		travel:   { title: 'No Travel Experiences Saved',   description: 'Discover more experiences like this. Start building your list of travel experiences.' },
		day:      { title: 'No Day Activities Saved',       description: 'Discover more experiences like this. Start building your list of day activities.' },
		online:   { title: 'No Online Experiences Saved',   description: 'Discover more experiences like this. Start building your list of online experiences.' },
		training: { title: 'No Training & Courses Saved',   description: 'Discover more experiences like this. Start building your list of training and courses.' },
	};

	function fetchTabData(tabValue) {
		const url = new URL(window.location.href);
		url.searchParams.delete('page');
		if (tabValue === 'all') {
			url.searchParams.delete('funnel');
		} else {
			url.searchParams.set('funnel', tabValue);
		}
		window.location.href = url.toString();
	}

	document.addEventListener('DOMContentLoaded', function() {
		const tabsContainer = document.querySelector('.favorites-content__tabs');
		if (!tabsContainer) return;

		// Restore active tab from URL on page load
		const initialTab = new URL(window.location.href).searchParams.get('funnel') || 'all';
		const initialTabEl = tabsContainer.querySelector(`[data-tab-value="${initialTab}"]`);
		if (initialTabEl) {
			tabsContainer.querySelectorAll('.favorites-content__tab').forEach(t => t.classList.remove('favorites-content__tab--active'));
			initialTabEl.classList.add('favorites-content__tab--active');
		}

		if (initialTab !== 'all' && TAB_EMPTY_STATE[initialTab]) {
			const emptyState = document.querySelector('.favorites-tab-empty-state');
			if (emptyState) {
				const titleEl = emptyState.querySelector('.favorites-tab-empty-state__title');
				const descEl = emptyState.querySelector('.favorites-tab-empty-state__description');
				if (titleEl) titleEl.textContent = TAB_EMPTY_STATE[initialTab].title;
				if (descEl) descEl.textContent = TAB_EMPTY_STATE[initialTab].description;
			}
		}

		tabsContainer.addEventListener('click', function(e) {
			const tab = e.target.closest('.favorites-content__tab');
			if (!tab) return;

			tabsContainer.querySelectorAll('.favorites-content__tab').forEach(t => {
				t.classList.remove('favorites-content__tab--active');
			});
			tab.classList.add('favorites-content__tab--active');

			fetchTabData(tab.dataset.tabValue);
		});
	});

	return {
		setActiveTab: (tabId) => {
			const tabsContainer = document.querySelector('.favorites-content__tabs');
			if (!tabsContainer) return;

			tabsContainer.querySelectorAll('.favorites-content__tab').forEach(tab => {
				if (tab.dataset.tabId === tabId) {
					tab.classList.add('favorites-content__tab--active');
				} else {
					tab.classList.remove('favorites-content__tab--active');
				}
			});
		}
	};
})();

